<template>
  <Modal v-model="open" :title="title">
    <Tree
      ref="Tree"
      :data="permitsData"
      show-checkbox
      check-directly
      check-strictly
      multiple
      @on-check-change="checkChange"
    ></Tree>
    <div slot="footer" style="text-align: center">
      <Button @click="cancel">关闭</Button>
      <Button type="primary" :loading="loading" @click="ok('Tree')">
        提交
      </Button>
    </div>
  </Modal>
</template>
<script>
import { permitsList } from '@/api/permit'
import { rolesSetPermits } from '@/api/role'
export default {
  name: 'rolesAddUpdate',
  data() {
    return {
      role_id: '',
      open: false,
      title: '分配权限',
      loading: false,
      auth_ids: '',
      permitsData: [
        {
          title: 'parent 1',
          id: 1,
          expand: true,
          selected: true,
          children: [
            {
              title: 'parent 1-1',
              id: 11,
              expand: true,
            },
          ],
        },
      ],
    }
  },
  methods: {
    // 初始化组件的函数，接收参数params
    init(params) {
      // 打印params参数，用于调试
      // console.log('params', params)
      // 从params中提取roleId和authIds，并设置组件的data属性
      this.role_id = params.roleId || params.role_id
      this.auth_ids = params.authIds || params.auth_ids
      // 设置模态框的标题
      this.title = '分配权限'
      // 显示模态框
      this.open = true
      // 调用getList方法获取权限列表
      this.getList()
    },
    // 获取权限列表的函数
    getList() {
      // 调用permitsList API获取权限列表
      permitsList()
        .then((res) => {
          // 处理成功的响应
          // 如果响应码为200，表示成功获取数据
          if (res.data.code === 200) {
            // 从响应数据中提取权限列表
            const data = res.data
            this.permitsData = data.data
            // 调用updateChildren方法更新权限数据，设置选中状态
            this.updateChildren()
          } else {
            // 如果响应码不是200，显示错误消息
            this.$Message.error(res.data.msg)
          }
        })
        .catch((err) => {
          // 处理错误的响应
          // 显示错误消息
          this.$Message.error(err)
        })
    },
    // 确认提交分配权限的函数
    ok(name) {
      // 获取所有选中的权限节点
      const temp = this.$refs[name].getCheckedNodes()
      // 创建一个空数组用于存储选中的节点ID
      const checks = []
      // 遍历选中的节点，将ID添加到checks数组中
      temp.map((item) => {
        checks.push(item.id)
      })
      console.log('checks', checks)
      // 准备提交的数据
      const postData = {
        auth_ids: checks.join(','), // 将选中的节点ID数组转换为字符串
        role_id: this.role_id, // 角色ID
      }
      // 显示加载状态
      this.loading = true
      // 调用rolesSetPermits API设置角色权限
      rolesSetPermits(postData)
        .then((res) => {
          // 处理成功的响应
          // 隐藏加载状态
          this.loading = false
          // 如果响应码为200，表示成功
          if (res.data.code === 200) {
            // 显示成功消息
            this.$Message.success('分配权限成功')
            // 调用cancel函数关闭模态框
            this.cancel()
            // 触发reload事件，通知父组件重新加载列表
            this.$emit('reload')
          } else {
            // 如果响应码不是200，显示错误消息
            this.$Message.error(res.data.msg)
          }
        })
        .catch((err) => {
          // 处理错误的响应
          // 隐藏加载状态
          this.loading = false
          // 显示错误消息
          this.$Message.error(err)
        })
    },
    // 取消操作并关闭模态框的函数
    cancel(name) {
      // 隐藏模态框
      this.open = false
    },
    // 权限选择变化时的回调函数
    checkChange(arr, item) {
      // 打印选中的权限数组和新选择的权限项，用于调试
      console.log('arr', arr, item);
    },
    // 更新权限数据，设置选中状态
    updateChildren() {
      // 初始化权限ID数组
      let authIds = ''
      // 如果auth_ids存在，将其转换为数组
      if (this.auth_ids) {
        authIds = this.auth_ids.split(',')
      }
      // 递归函数，用于更新权限数据
      function recursion(temp) {
        // 遍历权限数据
        temp.map((item) => {
          // 如果权限ID在数组中，设置该项为选中状态
          if (authIds.includes(item.id.toString())) {
            item.checked = true
          }
          // 更新标题为name属性
          item.title = item.name
          // 设置为展开状态
          item.expand = true
          // 如果有子节点，递归调用recursion更新子节点
          if (item.children.length) {
            recursion(item.children)
          }
        })
      }
      // 调用recursion函数，开始递归更新权限数据
      recursion(this.permitsData)
    },
  },
}
</script>
